import {
  Container,
  Icon,
  SecurityDescription,
  SecurityDescriptionTitle,
  SecurityDescriptionWrapper,
  SecurityInfoWrapper,
  SecutiryIconWrapper,
} from "./DataReceive.styles";

export default function DataReceive() {
  return (
    <>
      <Container id="data">
        <SecurityInfoWrapper>
          <SecutiryIconWrapper>
            <Icon src="images/lock.png" />
          </SecutiryIconWrapper>
          <SecurityDescriptionWrapper>
            <SecurityDescriptionTitle>Sua segurança, nossa prioridade</SecurityDescriptionTitle>
            <SecurityDescription>
              Não se preocupe! Todos os dados fornecidos estão seguros conosco, utilizamos a LGPD para proteger ainda mais suas informações confidenciais.
            </SecurityDescription>
          </SecurityDescriptionWrapper>
        </SecurityInfoWrapper>
      </Container>
    </>
  );
};